import { render, staticRenderFns } from "./TkCollapse.vue?vue&type=template&id=465105a0&"
import script from "./TkCollapse.vue?vue&type=script&lang=js&"
export * from "./TkCollapse.vue?vue&type=script&lang=js&"
import style0 from "./TkCollapse.vue?vue&type=style&index=0&id=465105a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports